import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { cloudStorage } from "@tma.js/sdk-react";

const LANGUAGE_STORAGE_KEY = "app_language";

const resources = {
  en: {
    translation: {
      info: "Info",
      scan: "Scan",
      add: "Add",
      dashboard: "Dashboard",
      manageUser: "Manage User",
      userProfile: "User Profile",
      manageGuest: "Manage Guest",
      rsvp: "RSVP",
      guestContribution: "Guest Contribution",
      report: "Report",
      scanQRCode: "Scan QR Code",
      close: "Close",
      noCamera: "No camera available",
      cameraPermissionDenied: "Camera permission denied",
      addGuest: "Add Guest",
      eventManagement: "Event Management",
      guestActivities: "Guest Activity & RSVPs",
      preferencesAndSupport: "Preferences & Support",
      session: "Account",
      appearance: "Appearance",
      themeMode: "Theme Mode",
      darkMode: "Dark Mode",
      lightMode: "Light Mode",
      // Manage Guest Page
      total: "Total",
      invited: "Invited",
      notInvited: "Not Invited",
      all: "All",
      guestList: "Guest List",
      searchGuests: "Search guests...",
      select: "Select",
      selectAll: "Select All",
      done: "Done",
      noGuestsFound: "No guests found",
      changeStatus: "Change Status",
      actions: "Actions",
      printQRCode: "Print QR Code",
      delete: "Delete",
      edit: "Edit",
      wishes: "Wishes",
      wish: "Wish",
      cancel: "Cancel",
      confirm: "Confirm",
      save: "Save",
      tag: "Tag",
      guestName: "Guest Name",
      guestNames: "Guest Names",
      guestNamesPlaceholder: "Enter guest names (one per line)",
      guestNamesHelper: "Enter each guest name on a new line",
      editGuest: "Edit Guest",
      deleteGuest: "Delete Guest",
      deleteGuests: "Delete Guests",
      deleteGuestConfirm: "Are you sure you want to delete {{name}}?",
      deleteGuestsConfirm: "Are you sure you want to delete {{count}} guests?",
      guestsCreated: "Guests created successfully",
      guestUpdated: "Guest updated successfully",
      guestDeleted: "Guest deleted successfully",
      guestsDeleted: "{{count}} guests deleted successfully",
      guestsStatusUpdated: "{{count}} guests status updated",
      fetchGuestsError: "Failed to fetch guests",
      createGuestsError: "Failed to create guests",
      updateGuestError: "Failed to update guest",
      deleteGuestError: "Failed to delete guest",
      deleteGuestsError: "Failed to delete guests",
      updateGuestsStatusError: "Failed to update guests status",
      printQRCodeFeature: "Print QR Code feature coming soon",
      // Search & Filter
      allTags: "All Tags",
      searchByNameOrTag: "Search by name or tag...",
      searchByNameTagOrNote: "Search by name, tag, or note...",
      // Print QR Code
      downloadQRCode: "Download QR Code",
      download: "Download",
      downloading: "Downloading...",
      invitationLink: "Invitation Link",
      shareVia: "Share via",
      invitationFor: "Invitation for",
      guestNotFound: "Guest not found",
      // Wishes
      wishesFrom: "Wishes From",
      attend: "Attend",
      attendingGuests: "Attending Guests",
      yes: "Yes",
      no: "No",
      show: "Show",
      hide: "Hide",
      noWishesFound: "No wishes found",
      noWishesDescription: "Try adjusting your search or filter criteria",
      noGuestsDescription: "Try adjusting your search or filter criteria",
      wishVisibilityUpdated: "Wish visibility updated",
      wishVisibilityError: "Failed to update wish visibility",
      createdAt: "Created At",
      updatedAt: "Updated At",
      responseAt: "Response At",
      // Bulk Print
      printGuestList: "Print Guest List",
      settings: "Settings",
      guestNameSize: "Guest Name Size",
      qrCodeSize: "QR Code Size",
      fontSize: "Font Size",
      width: "Width",
      height: "Height",
      print: "Print",
      totalGuests: "Total Guests",
      qrCodes: "QR Codes",
      noGuestsSelected: "No guests selected",
      backToGuestList: "Back to Guest List",
      small: "Small",
      medium: "Medium",
      large: "Large",
      custom: "Custom",
      // Add Guest Page
      enterGuestName: "Enter guest name",
      selectOrCreateTag: "Select or create tag",
      // Wishes List
      mayBe: "May Be",
      notAttend: "Not Attend",
      notResponse: "Not Response",
      usd: "USD",
      khr: "KHR",
      cash: "Cash",
      qrCode: "QR Code",
      QRCode: "QR កូដ",
      // Dashboard
      totalGuest: "Total Guest",
      totalWishes: "Total Wishes",
      notInvitedGuest: "Not Invited Guest",
      totalGuestStatus: "Total Guest Status",
      totalGuestContribution: "Total Guest Contribution",
      grandTotal: "Grand Total",
      attendGuest: "Attend Guest",
      notAttendGuest: "Not Attend Guest",
      pendingResponse: "Pending Response",
      walkInGuest: "Walk-in Guest",
      usdGuest: "USD Guest",
      khrGuest: "KHR Guest",
      // Report
      reportGuest: "Report Guest",
      reportRSVP: "Report RSVP",
      reportContribution: "Report Contribution",
      addContribution: "Add Contribution",
      editContribution: "Edit Contribution",
      manageTags: "Manage Tags",
      reorderTags: "Reorder Tags",
      reorderTagsDescription: "Drag the handle to reorder tags",
      tagsReorderedSuccessfully: "Tags reordered successfully",
      failedToReorderTags: "Failed to reorder tags",
      moveUp: "Move Up",
      moveDown: "Move Down",
      addTag: "Add Tag",
      editTag: "Edit Tag",
      tagName: "Tag Name",
      enterTagName: "Enter tag name",
      noTagsYet: "No tags yet. Create your first tag!",
      deleteContributionConfirm:
        "Are you sure you want to delete contribution from {{name}}?",
      contributionDeleted: "Contribution deleted",
      contributionDeletedSuccess:
        "The contribution has been deleted successfully",
      deleteFailed: "Delete failed",
      deleteFailedDescription:
        "Failed to delete contribution. Please try again.",
      noContributionsFound: "No contributions found",
      noContributionsDescription:
        "Try adjusting your search or filter criteria",
      amountMustBePositive: "Amount must be greater than 0",
      currencyRequired: "Currency is required",
      selectCurrency: "Select Currency",
      noContributions: "No contributions yet",
      create: "Create",
      update: "Update",
      selectLanguage: "Select Language",
      language: "Language",
      template: "Template",
      detail: "Detail",
      copied: "Copied",
      statusUpdateError: "Failed to update status",
      quickSelect: "Quick Select",
      tagNames: "Multiple Tags",
      other: "Other",
      // User Profile
      profileNotFound: "Profile not found",
      fullName: "Full Name",
      email: "Email",
      phone: "Phone",
      role: "Role",
      status: "Status",
      active: "Active",
      inactive: "Inactive",
      memberSince: "Member Since",
      lastUpdated: "Last Updated",
      // Import/Export
      downloadTemplate: "Download Template",
      uploadGuests: "Upload Guests",
      exportGuests: "Export Guests",
      templateDownloaded: "Template downloaded successfully",
      downloadTemplateFailed: "Failed to download template",
      guestsUploadedSuccessfully: "Guests uploaded successfully",
      uploadGuestsFailed: "Failed to upload guests",
      guestsExportedSuccessfully: "Guests exported successfully",
      exportGuestsFailed: "Failed to export guests",
      export: "Export",
      exporting: "Exporting...",
      logout: "Logout",
      filter: "Filter",
      filterByTags: "Filter By Tags",
      share: "Share",
      visibility: "Visibility",
      setting: "Setting",
      currency: "Currency",
      exchangeRate: "Exchange Rate",
      addCurrency: "Add Currency",
      editCurrency: "Edit Currency",
      currencyCode: "Currency Code",
      currencyName: "Currency Name",
      noCurrenciesFound: "No currencies found",
      currencyCreatedSuccessfully: "Currency created successfully",
      currencyUpdatedSuccessfully: "Currency updated successfully",
      currencyDeletedSuccessfully: "Currency deleted successfully",
      failedToLoadCurrencies: "Failed to load currencies",
      addExchangeRate: "Add Exchange Rate",
      editExchangeRate: "Edit Exchange Rate",
      rate: "Rate",
      noExchangeRatesFound: "No exchange rates found",
      confirmDeleteWithName: "Are you sure you want to delete {{name}}?",
      exchangeRateCreatedSuccessfully: "Exchange rate created successfully",
      exchangeRateUpdatedSuccessfully: "Exchange rate updated successfully",
      exchangeRateDeletedSuccessfully: "Exchange rate deleted successfully",
      failedToLoadExchangeRates: "Failed to load exchange rates",
      pleaseCompleteAllFields: "Please complete all fields",
      operationFailed: "Operation failed",
      confirmDelete: "Are you sure you want to delete this?",
      // Guest Detail
      contributionNotFound: "Contribution not found",
      guestDetail: "Guest Detail",
      userName: "User Name",
      invitedAt: "Invited At",
      rsvpSummary: "RSVP Summary",
      respondedAt: "Responded At",
      guestWishes: "Guest Wishes",
      contributionSummary: "Contribution Summary",
      paymentAt: "Payment At",
      paymentType: "Payment Type",
      currencyType: "Currency Type",
      amount: "Amount",
      guestNote: "Guest Note",
      walkIn: "Walk In",
      enterName: "Enter Name",
      enterNote: "Enter Note",
      // ManageTags
      validationError: "Validation Error",
      tagNameRequired: "Tag name is required",
      duplicateTag: "Duplicate Tag",
      tagAlreadyExists: "This tag already exists",
      tagUpdatedSuccessfully: "Tag updated successfully",
      tagCreatedSuccessfully: "Tag created successfully",
      tagDeleted: "Tag Deleted",
      tagDeletedSuccess: 'Tag "{{name}}" has been deleted successfully',
      tagDeleteFailed: "Delete Failed",
      tagDeleteFailedDescription: "Failed to delete tag. Please try again.",
      failedToUpdateTag: "Failed to update tag. Please try again.",
      failedToCreateTag: "Failed to create tag. Please try again.",
      deleteTagConfirm: 'Are you sure you want to delete tag "{{name}}"?',
      // Contribution Form
      failedToLoadGuestFromQR: "Failed to load guest from QR code",
      pleaseRetryAgain: "Please try again",
      contributionUpdatedSuccessfully: "Updated successfully!",
      contributionSavedSuccessfully: "Saved successfully!",
      failedToUpdateContribution:
        "Failed to update contribution. Please try again.",
      failedToSaveContribution:
        "Failed to save contribution. Please try again.",
      // Guest name not required
      guestNameRequired: "Guest name is required",
      // Exchange rate form
      from: "From",
      to: "To",
      record: "Record",
      totalRecords: "Total",
      notificationLanguage: "Notification Language",
      notificationLanguageUpdated: "Notification Language updated successfully",
      failedToUpdateNotificationLanguage:
        "Failed to update notification language",
      messageAndSeoConfig: "Message & SEO Config",
      guestInviteMessage: "Guest Invite Message",
      invitationTemplate: "Invitation Representative",
      invitationTemplates: "Invitation Representative",
      invitationRepresentative: "Invitation Representative",
      invitationTemplateSubtitle: "Messages by sender representative (Parents or Family)",
      invitationRepresentativeSubtitle: "Messages by sender representative (Parents or Family)",
      representative: "Representative",
      defaultInvitationMessage: "Default",
      coupleInvitation: "Host",
      couple: "Couple",
      selectInvitationTemplate: "Select Representative",
      parentsInvitation: "Parents' Invitation",
      familyInvitation: "Family's Invitation",
      senderType: "Sender Type",
      labelKh: "Khmer Label",
      labelEn: "English Label",
      tapToInsertPlaceholder: "Tap to insert placeholder",
      addInvitationTemplate: "Add Another Sender Representative (PARENTS / FAMILY)",
      noInvitationTemplates: "No invitation representatives configured yet",
      noInvitationTemplatesDesc: "Configure sender-specific representatives for Parents or Family",
      configureTemplates: "Configure Representatives",
      invitationTemplatesSavedSuccess: "Invitation representatives updated successfully",
      invitationTemplatesSaveError: "Failed to update invitation representatives",
      confirmDeleteTemplate: "Delete Invitation Representative?",
      confirmDeleteTemplateDesc: "Are you sure you want to remove this invitation representative?",
      confirmClearAllTemplates: "Clear All Invitation Representatives?",
      confirmClearAllTemplatesDesc: "This will clear all representatives to empty list []. Saving will update the configuration on the server.",
      linkPreviewTitle: "Link Preview Title",
      linkPreviewDescription: "Link Preview Description",
      guestInviteMessageDesc: "Customize invitation message for Telegram chat",
      linkPreviewTitleDesc: "Customize link preview title & description for social sharing",
      saveGuestInviteSuccess: "Guest invite message updated successfully",
      saveLinkPreviewSuccess: "Link preview configuration updated successfully",
      resetToDefault: "Reset to Default",
      resetToDefaultSuccess: "Reset to default template successfully",
      invitationMessage: "Invitation Message",
      seoMessage: "SEO Message",
      seoTitle: "SEO Title",
      seoDescription: "SEO Description",
      saveMessagesSuccess: "Message & SEO configuration updated successfully",
      failedToLoadMessages: "Failed to load message & SEO configuration",
      saveMessagesError: "Failed to update message & SEO configuration",
      languageEn: "English",
      languageKh: "Khmer",
      languageCh: "Chinese",
      // Contact Us
      feedback: "Feedback",
      selectTopic: "Select Topic",
      generalQuestion: "General Question",
      partnership: "Partnership",
      feedbackTab: "Feedback",
      phoneNumber: "Phone Number",
      companyName: "Company Name",
      inquiryTopic: "Inquiry Topic",
      partnershipType: "Partnership Type",
      feedbackType: "Feedback Type",
      ratingLabel: "Rating",
      howCanWeHelp: "How Can We Help?",
      proposalDetails: "Proposal Details",
      yourFeedback: "Your Feedback / Suggestions",
      submitMessage: "Submit",
      submitSuccess: "Thank you! Your message has been sent successfully.",
      submitError: "Submission failed. Please try again.",
      optional: "Optional",
      required: "Required",
      pricingPackages: "Pricing & Packages",
      customDesignTheme: "Custom Design & Theme",
      guestListQR: "Guest List & QR Code",
      technicalAccountHelp: "Technical & Account Help",
      otherQuestion: "Other Question",
      eventPlannerAgency: "Event Planner / Agency",
      designerArtist: "Designer & Artist",
      vendorSponsor: "Vendor & Sponsor",
      affiliateReseller: "Affiliate & Reseller",
      otherCollaboration: "Other Collaboration",
      testimonial: "Testimonial",
      suggestion: "Suggestion",
      issueReport: "Issue Report",
      emailUs: "Email Us",
      callUs: "Call Us",
      visitUs: "Visit Us",
      companyAddress: "Street 1984, Phnom Penh, Cambodia",
      typicalResponseTime: "Typical response time: within 2 hours",
      fullNameRequired: "Full name is required",
      emailRequired: "Email is required",
      emailInvalid: "Please enter a valid email",
      messageRequired: "Message is required",
      phoneMinLength: "Phone number must be at least 6 digits",
      phoneMaxLength: "Phone number cannot exceed 12 digits",
      companyNameRequired: "Company name is required",
      // Thank You Message
      thankYouMessage: "Thank You Message",
      thankYouSubtitle: "Customize thank-you media & note shown to guests",
      thankYouPhotoTitle: "THANK YOU PHOTO",
      thankYouVideoLinkTitle: "VIDEO MESSAGE LINK (OPTIONAL)",
      thankYouMessageTextTitle: "THANK YOU MESSAGE TEXT",
      thankYouImage: "Thank You Image",
      thankYouVideoLink: "Thank You Video Link",
      message: "Message",
      messageKh: "Message (KH)",
      messageEn: "Message (EN)",
      messageCh: "Message (CH)",
      thankYouSaveSuccess: "Thank you message saved successfully",
      thankYouSaveError: "Failed to save thank you message",
      uploadThankYouPhoto: "Upload Thank You Photo",
      uploadImage: "Upload Image",
      changeImage: "Change Image",
      removeImage: "Remove Image",
      uploading: "Uploading...",
      uploadFailed: "Upload failed",
      fileUploadedSuccessfully: "Image uploaded successfully",
      mediaDeletedSuccessfully: "Image deleted successfully",
      // SEO Preview Enhancement
      editMode: "Edit",
      previewMode: "Preview",
      socialSharePreview: "Social Media Share Preview",
      invitationMessagePreview: "Invitation Message Preview",
      noImageSelected: "No Image Selected",
      eventInvitation: "Event Invitation",
      pleaseAttendOurSpecialDay: "Please attend our special day",
      enterInvitationMessage:
        "Enter an invitation message to see dynamic preview",
      // User Guide
      userGuide: "User Guides",
      userGuideTitle: "User Guides",
      userGuideSubtitle: "Learn how to set up and manage your digital invitation",
      searchGuidePlaceholder: "Search guides by title, feature, or event...",
      gettingStarted: "Getting Started",
      gettingStartedDesc: "Getting started tutorial video will be available soon.",
      noGettingStartedVideo: "No getting started video currently available.",
      guidesByEvent: "Guides by Event",
      guidesByEventDesc: "Select an event type to view specialized tutorial videos.",
      allEvents: "All Events",
      featureGuides: "Feature Guides",
      featureGuidesDesc: "Learn how to manage guests, RSVPs, contributions, wishes, and settings.",
      watchGuide: "Watch Guide",
      viewGuides: "View Guides",
      exploreTutorials: "Explore setup tutorials & tips",
      prevVideo: "Previous Video",
      nextVideo: "Next Video",
      videoCounter: "{{current}} / {{total}} Videos",
      upNext: "Up Next ({{count}})",
      part: "Part #{{number}}",
      partGuide: "Part #{{order}} • E-THEAP Guide",
      noEventGuidesTitle: "No event guides available",
      noEventGuidesDesc: "There are no guide videos listed for this event type yet.",
      noFeatureGuidesTitle: "No feature guides available",
      noFeatureGuidesDesc: "Check back soon for new feature tutorials.",
      noGuidesForEventDesc: "No videos listed for this event yet.",
    },
  },
  kh: {
    translation: {
      info: "ព័ត៌មាន",
      scan: "ស្កេន",
      add: "បន្ថែម",
      dashboard: "ផ្ទាំងគ្រប់គ្រង",
      manageUser: "គ្រប់គ្រងអ្នកប្រើប្រាស់",
      userProfile: "ប្រវត្តិរូបអ្នកប្រើប្រាស់",
      manageGuest: "គ្រប់គ្រងភ្ញៀវ",
      rsvp: "សារពីភ្ញៀវ",
      guestContribution: "ការចូលរួមពីភ្ញៀវ",
      report: "របាយការណ៍",
      scanQRCode: "ស្កេន QR កូដ",
      close: "បិទ",
      noCamera: "មិនមានកាមេរ៉ា",
      cameraPermissionDenied: "មិនអនុញ្ញាតឱ្យប្រើកាមេរ៉ា",
      addGuest: "បន្ថែមភ្ញៀវ",
      eventManagement: "ការគ្រប់គ្រងកម្មវិធី",
      guestActivities: "សកម្មភាពភ្ញៀវ និងការឆ្លើយតប",
      preferencesAndSupport: "ការកំណត់ និងជំនួយ",
      session: "គណនី",
      appearance: "រូបរាង",
      themeMode: "ទម្រង់ពន្លឺ/ងងឹត",
      darkMode: "ទម្រង់ងងឹត",
      lightMode: "ទម្រង់ពន្លឺ",
      // Manage Guest Page
      total: "សរុប",
      invited: "បានអញ្ជើញ",
      notInvited: "មិនទាន់អញ្ជើញ",
      all: "ទាំងអស់",
      guestList: "បញ្ជីភ្ញៀវ",
      searchGuests: "ស្វែងរកភ្ញៀវ...",
      select: "ជ្រើសរើស",
      selectAll: "ជ្រើសរើសទាំងអស់",
      done: "រួចរាល់",
      noGuestsFound: "រកមិនឃើញភ្ញៀវ",
      changeStatus: "ប្តូរស្ថានភាព",
      actions: "សកម្មភាព",
      printQRCode: "បោះពុម្ព QR កូដ",
      delete: "លុប",
      edit: "កែសម្រួល",
      wishes: "សារ",
      wish: "សារ",
      cancel: "បោះបង់",
      confirm: "បញ្ជាក់",
      save: "រក្សាទុក",
      tag: "ស្លាក",
      guestName: "ឈ្មោះភ្ញៀវ",
      guestNames: "ឈ្មោះភ្ញៀវ",
      guestNamesPlaceholder: "បញ្ចូលឈ្មោះភ្ញៀវ (មួយជួរមួយឈ្មោះ)",
      guestNamesHelper: "បញ្ចូលឈ្មោះភ្ញៀវនីមួយៗនៅលើជួរថ្មី",
      editGuest: "កែសម្រួលភ្ញៀវ",
      deleteGuest: "លុបភ្ញៀវ",
      deleteGuests: "លុបភ្ញៀវ",
      deleteGuestConfirm: "តើអ្នកប្រាកដថាចង់លុប {{name}} មែនទេ?",
      deleteGuestsConfirm: "តើអ្នកប្រាកដថាចង់លុបភ្ញៀវ {{count}} នាក់មែនទេ?",
      guestsCreated: "បានបង្កើតភ្ញៀវដោយជោគជ័យ",
      guestUpdated: "បានកែសម្រួលភ្ញៀវដោយជោគជ័យ",
      guestDeleted: "បានលុបភ្ញៀវដោយជោគជ័យ",
      guestsDeleted: "បានលុបភ្ញៀវ {{count}} នាក់ដោយជោគជ័យ",
      guestsStatusUpdated: "បានកែសម្រួលស្ថានភាពភ្ញៀវ {{count}} នាក់",
      fetchGuestsError: "មិនអាចទាញយកភ្ញៀវបានទេ",
      createGuestsError: "មិនអាចបង្កើតភ្ញៀវបានទេ",
      updateGuestError: "មិនអាចកែសម្រួលភ្ញៀវបានទេ",
      deleteGuestError: "មិនអាចលុបភ្ញៀវបានទេ",
      deleteGuestsError: "មិនអាចលុបភ្ញៀវបានទេ",
      updateGuestsStatusError: "មិនអាចកែសម្រួលស្ថានភាពភ្ញៀវបានទេ",
      printQRCodeFeature: "មុខងារបោះពុម្ព QR កូដនឹងមកដល់ឆាប់ៗនេះ",
      allTags: "ស្លាកទាំងអស់",
      searchByNameOrTag: "ស្វែងរកតាមឈ្មោះ ឬស្លាក...",
      searchByNameTagOrNote: "ស្វែងរកតាមឈ្មោះ ស្លាក ឬកំណត់ចំណាំ...",
      downloadQRCode: "ទាញយក QR កូដ",
      download: "ទាញយក",
      downloading: "កំពុងទាញយក...",
      invitationLink: "តំណភ្ជាប់អញ្ជើញ",
      shareVia: "ចែករំលែកតាម",
      invitationFor: "អញ្ជើញសម្រាប់",
      guestNotFound: "រកមិនឃើញភ្ញៀវ",
      wishesFrom: "សារពី",
      attend: "ចូលរួម",
      attendingGuests: "ចំនួនភ្ញៀវចូលរួម",
      yes: "បាទ/ចាស",
      no: "ទេ",
      show: "បង្ហាញ",
      hide: "លាក់",
      noWishesFound: "រកមិនឃើញសារ",
      noWishesDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      noGuestsDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      wishVisibilityUpdated: "ការមើលឃើញបំណងប្រាថ្នាត្រូវបានធ្វើបច្ចុប្បន្នភាព",
      wishVisibilityError:
        "បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពការមើលឃើញបំណងប្រាថ្នា",
      createdAt: "បង្កើតនៅ",
      updatedAt: "ធ្វើបច្ចុប្បន្នភាពនៅ",
      responseAt: "ឆ្លើយតបនៅ",
      // Bulk PrintGuestList: "បោះពុម្ពបញ្ជីភ្ញៀវ",
      settings: "ការកំណត់",
      guestNameSize: "ទំហំឈ្មោះភ្ញៀវ",
      qrCodeSize: "ទំហំ QR កូដ",
      fontSize: "ទំហំអក្សរ",
      width: "ទទឹង",
      height: "កម្ពស់",
      print: "បោះពុម្ព",
      totalGuests: "ភ្ញៀវសរុប",
      qrCodes: "QR កូដ",
      noGuestsSelected: "មិនបានជ្រើសរើសភ្ញៀវ",
      backToGuestList: "ត្រឡប់ទៅបញ្ជីភ្ញៀវ",
      small: "តូច",
      medium: "មធ្យម",
      large: "ធំ",
      custom: "ផ្ទាល់ខ្លួន",
      enterGuestName: "បញ្ចូលឈ្មោះភ្ញៀវ",
      selectOrCreateTag: "ជ្រើសរើស ឬបង្កើតស្លាក",
      mayBe: "ប្រហែល",
      notAttend: "មិនចូលរួម",
      notResponse: "មិនទាន់ឆ្លើយ",
      usd: "ដុល្លារ",
      khr: "រៀល",
      cash: "ប្រាក់",
      qrCode: "QR កូដ",
      QRCode: "QR កូដ",
      // Dashboard
      totalGuest: "ភ្ញៀវសរុប",
      totalWishes: "សារសរុប",
      notInvitedGuest: "ភ្ញៀវមិនទាន់អញ្ជើញ",
      totalGuestStatus: "ស្ថានភាពភ្ញៀវសរុប",
      totalGuestContribution: "ការចូលរួមពីភ្ញៀវសរុប",
      grandTotal: "សរុបរួម",
      attendGuest: "ភ្ញៀវចូលរួម",
      notAttendGuest: "ភ្ញៀវមិនចូលរួម",
      pendingResponse: "រង់ចាំការឆ្លើយតប",
      walkInGuest: "ភ្ញៀវចូលរួម",
      usdGuest: "ភ្ញៀវ USD",
      khrGuest: "ភ្ញៀវ KHR",
      // Report
      reportGuest: "របាយការណ៍ភ្ញៀវ",
      reportRSVP: "របាយការណ៍RSVP",
      reportContribution: "របាយការណ៍ការចូលរួម",
      addContribution: "បន្ថែមការចូលរួម",
      editContribution: "កែសម្រួលការចូលរួម",
      manageTags: "គ្រប់គ្រងស្លាក",
      reorderTags: "រៀបចំស្លាកឡើងវិញ",
      reorderTagsDescription: "អូសចំណុចទាញដើម្បីរៀបចំលំដាប់ស្លាកឡើងវិញ",
      tagsReorderedSuccessfully: "បានរៀបចំស្លាកឡើងវិញដោយជោគជ័យ",
      failedToReorderTags: "បរាជ័យក្នុងការរៀបចំស្លាកឡើងវិញ",
      moveUp: "រំកិលឡើងលើ",
      moveDown: "រំកិលចុះក្រោម",
      addTag: "បន្ថែមស្លាក",
      editTag: "កែសម្រួលស្លាក",
      tagName: "ឈ្មោះស្លាក",
      enterTagName: "បញ្ចូលឈ្មោះស្លាក",
      noTagsYet: "មិនទាន់មានស្លាកនៅឡើយទេ។ បង្កើតស្លាកដំបូងរបស់អ្នក!",
      deleteContributionConfirm:
        "តើអ្នកប្រាកដថាចង់លុបការចូលរួមពី {{name}} មែនទេ?",
      contributionDeleted: "បានលុបការចូលរួម",
      contributionDeletedSuccess: "ការចូលរួមត្រូវបានលុបដោយជោគជ័យ",
      deleteFailed: "លុបមិនបានជោគជ័យ",
      deleteFailedDescription: "មិនអាចលុបការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      noContributionsFound: "រកមិនឃើញការចូលរួម",
      noContributionsDescription: "សូមព្យាយាមកែសម្រួលលក្ខខណ្ឌស្វែងរក ឬតម្រង",
      amountMustBePositive: "ចំនួនទឹកប្រាក់ត្រូវតែធំជាង 0",
      currencyRequired: "ត្រូវការរូបិយប័ណ្ណ",
      selectCurrency: "ជ្រើសរើសរូបិយប័ណ្ណ",
      noContributions: "មិនទាន់មានការចូលរួមនៅឡើយទេ",
      create: "បង្កើត",
      update: "ធ្វើបច្ចុប្បន្នភាព",
      selectLanguage: "ជ្រើសរើសភាសា",
      language: "ភាសា",
      template: "ទម្រង់",
      detail: "លម្អិត",
      copied: "បានចម្លង",
      statusUpdated: "បានអញ្ជើញរួចរាល់",
      cancelStatus: "បោះបង់ការអញ្ជើញ",
      statusUpdateError: "បរាជ័យក្នុងការធ្វើបច្ចុប្បន្នភាពស្ថានភាព",
      quickSelect: "ជ្រើសរើសរហ័ស",
      tagNames: "ស្លាក​ជាច្រើន",
      other: "ផ្សេងទៀត",
      // User Profile
      profileNotFound: "រកមិនឃើញប្រវត្តិរូប",
      fullName: "ឈ្មោះពេញ",
      email: "អ៊ីមែល",
      phone: "លេខទូរស័ព្ទ",
      role: "តួនាទី",
      status: "ស្ថានភាព",
      active: "សកម្ម",
      inactive: "អសកម្ម",
      memberSince: "សមាជិកតាំងពី",
      lastUpdated: "ធ្វើបច្ចុប្បន្នភាពចុងក្រោយ",
      // Import/Export
      downloadTemplate: "ទាញយកគំរូ",
      uploadGuests: "បញ្ចូលភ្ញៀវ",
      exportGuests: "នាំចេញភ្ញៀវ",
      templateDownloaded: "បានទាញយកគំរូដោយជោគជ័យ",
      downloadTemplateFailed: "បរាជ័យក្នុងការទាញយកគំរូ",
      guestsUploadedSuccessfully: "បានបញ្ចូលភ្ញៀវដោយជោគជ័យ",
      uploadGuestsFailed: "បរាជ័យក្នុងការបញ្ចូលភ្ញៀវ",
      guestsExportedSuccessfully: "បាននាំចេញភ្ញៀវដោយជោគជ័យ",
      exportGuestsFailed: "បរាជ័យក្នុងការនាំចេញភ្ញៀវ",
      export: "ទាញយក",
      exporting: "កំពុងទាញយក...",
      logout: "ចាកចេញ",
      filter: "ស្វែងរក",
      filterByTags: "ជ្រើសរើសតាមស្លាក",
      share: "ចែករំលែក",
      visibility: "បង្ហាញ",
      setting: "ការកំណត់",
      currency: "រូបិយប័ណ្ណ",
      exchangeRate: "អត្រាប្តូរប្រាក់",
      addCurrency: "បន្ថែមរូបិយប័ណ្ណ",
      editCurrency: "កែសម្រួលរូបិយប័ណ្ណ",
      currencyCode: "លេខកូដរូបិយប័ណ្ណ",
      currencyName: "ឈ្មោះរូបិយប័ណ្ណ",
      noCurrenciesFound: "រកមិនឃើញរូបិយប័ណ្ណ",
      currencyCreatedSuccessfully: "បានបង្កើតរូបិយប័ណ្ណដោយជោគជ័យ",
      currencyUpdatedSuccessfully: "បានកែសម្រួលរូបិយប័ណ្ណដោយជោគជ័យ",
      currencyDeletedSuccessfully: "បានលុបរូបិយប័ណ្ណដោយជោគជ័យ",
      failedToLoadCurrencies: "មិនអាចទាញយករូបិយប័ណ្ណបានទេ",
      addExchangeRate: "បន្ថែមអត្រាប្តូរប្រាក់",
      editExchangeRate: "កែសម្រួលអត្រាប្តូរប្រាក់",
      rate: "អត្រា",
      noExchangeRatesFound: "រកមិនឃើញអត្រាប្តូរប្រាក់",
      exchangeRateCreatedSuccessfully: "បានបង្កើតអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      exchangeRateUpdatedSuccessfully: "បានកែសម្រួលអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      exchangeRateDeletedSuccessfully: "បានលុបអត្រាប្តូរប្រាក់ដោយជោគជ័យ",
      failedToLoadExchangeRates: "មិនអាចទាញយកអត្រាប្តូរប្រាក់បានទេ",
      confirmDeleteWithName: "តើអ្នកប្រាកដថាចង់លុប {{name}} មែនទេ?",
      pleaseCompleteAllFields: "សូមបំពេញព័ត៌មានទាំងអស់",
      operationFailed: "ប្រតិបត្តិការបរាជ័យ",
      confirmDelete: "តើអ្នកប្រាកដថាចង់លុបវាមែនទេ?",
      // Guest Detail
      contributionNotFound: "រកមិនឃើញការចូលរួម",
      guestDetail: "ព័ត៌មានភ្ញៀវ",
      userName: "ឈ្មោះអ្នកប្រើ",
      invitedAt: "អញ្ជើញនៅ",
      rsvpSummary: "សង្ខេប RSVP",
      respondedAt: "ឆ្លើយតបនៅ",
      guestWishes: "សារភ្ញៀវ",
      contributionSummary: "សង្ខេបការចូលរួម",
      paymentAt: "បង់ប្រាក់នៅ",
      paymentType: "ប្រភេទការបង់ប្រាក់",
      currencyType: "ប្រភេទរូបិយប័ណ្ណ",
      amount: "ចំនួនទឹកប្រាក់",
      guestNote: "កំណត់ចំណាំ",
      walkIn: "ភ្ញៀវផ្ទាល់",
      enterName: "បញ្ចូលឈ្មោះ",
      enterNote: "បញ្ចូលចំណាំ",
      // ManageTags
      validationError: "កំហុសក្នុងការផ្ទៀងផ្ទាត់",
      tagNameRequired: "ត្រូវការឈ្មោះស្លាក",
      duplicateTag: "ស្លាកស្ទួន",
      tagAlreadyExists: "ស្លាកនេះមានរួចហើយ",
      tagUpdatedSuccessfully: "បានកែសម្រួលស្លាកដោយជោគជ័យ",
      tagCreatedSuccessfully: "បានបង្កើតស្លាកដោយជោគជ័យ",
      tagDeleted: "បានលុបស្លាក",
      tagDeletedSuccess: 'ស្លាក "{{name}}" ត្រូវបានលុបដោយជោគជ័យ',
      tagDeleteFailed: "លុបស្លាកបរាជ័យ",
      tagDeleteFailedDescription: "មិនអាចលុបស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToUpdateTag: "មិនអាចកែសម្រួលស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToCreateTag: "មិនអាចបង្កើតស្លាកបានទេ។ សូមព្យាយាមម្តងទៀត។",
      deleteTagConfirm: 'តើអ្នកប្រាកដថាចង់លុបស្លាក "{{name}}" មែនទេ?',
      // Contribution Form
      failedToLoadGuestFromQR: "មិនអាចទាញយកភ្ញៀវវាពី QR កូដបានទេ",
      pleaseRetryAgain: "សូមព្យាយាមម្តងទៀត",
      contributionUpdatedSuccessfully: "បានកែសម្រួលដោយជោគជ័យ!",
      contributionSavedSuccessfully: "បានរក្សាទុកដោយជោគជ័យ!",
      failedToUpdateContribution:
        "មិនអាចកែសម្រួលការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      failedToSaveContribution:
        "មិនអាចរក្សាទុកការចូលរួមបានទេ។ សូមព្យាយាមម្តងទៀត។",
      // Guest name not required
      guestNameRequired: "ត្រូវការឈ្មោះភ្ញៀវ",
      // Exchange rate form
      from: "ពី",
      to: "ទៅ",
      record: "កត់ចំណងដៃ",
      totalRecords: "សរុប",
      notificationLanguage: "ភាសាដែលទទួលការជូនដំណឹង",
      notificationLanguageUpdated:
        "បានកែសម្រួលភាសាដែលចង់ទទួលការជូនដំណឹងដោយជោគជ័យ",
      failedToUpdateNotificationLanguage: "មិនអាចកែសម្រួលភាសាដែលចង់បានទេ",
      messageAndSeoConfig: "ការកំណត់សារ & SEO",
      guestInviteMessage: "សារអញ្ជើញភ្ញៀវ",
      invitationTemplate: "តំណាងអ្នកអញ្ជើញ",
      invitationTemplates: "តំណាងអ្នកអញ្ជើញ",
      invitationRepresentative: "តំណាងអ្នកអញ្ជើញ",
      invitationTemplateSubtitle: "សារអញ្ជើញតាមតំណាងអ្នកផ្ញើ (ឪពុកម្តាយ ឬ ក្រុមគ្រួសារ)",
      invitationRepresentativeSubtitle: "សារអញ្ជើញតាមតំណាងអ្នកផ្ញើ (ឪពុកម្តាយ ឬ ក្រុមគ្រួសារ)",
      representative: "តំណាង",
      defaultInvitationMessage: "លំនាំដើម",
      coupleInvitation: "សាមីខ្លួន",
      couple: "គូស្វាមីភរិយា",
      selectInvitationTemplate: "ជ្រើសរើសតំណាងអ្នកអញ្ជើញ",
      parentsInvitation: "លិខិតអញ្ជើញពីឪពុកម្តាយ",
      familyInvitation: "លិខិតអញ្ជើញពីក្រុមគ្រួសារ",
      senderType: "ប្រភេទអ្នកផ្ញើ",
      labelKh: "ស្លាកភាសាខ្មែរ",
      labelEn: "ស្លាកភាសាអង់គ្លេស",
      tapToInsertPlaceholder: "ចុចដើម្បីបញ្ចូលអថេរ",
      addInvitationTemplate: "បន្ថែមតំណាងអ្នកផ្ញើថ្មី (PARENTS / FAMILY)",
      noInvitationTemplates: "មិនទាន់មានកំណត់តំណាងអ្នកអញ្ជើញនៅឡើយទេ",
      noInvitationTemplatesDesc: "កំណត់សារអញ្ជើញតាមតំណាងអ្នកផ្ញើជាឪពុកម្តាយ ឬ ក្រុមគ្រួសារ",
      configureTemplates: "កំណត់តំណាងអ្នកផ្ញើ",
      invitationTemplatesSavedSuccess: "បានធ្វើបច្ចុប្បន្នភាពតំណាងអ្នកអញ្ជើញដោយជោគជ័យ",
      invitationTemplatesSaveError: "មិនអាចធ្វើបច្ចុប្បន្នភាពតំណាងអ្នកអញ្ជើញបានទេ",
      confirmDeleteTemplate: "តើអ្នកពិតជាចង់លុបតំណាងអ្នកអញ្ជើញនេះមែនទេ?",
      confirmDeleteTemplateDesc: "តើអ្នកប្រាកដថាចង់លុបតំណាងអ្នកអញ្ជើញនេះចេញពីបញ្ជីមែនទេ?",
      confirmClearAllTemplates: "សម្អាតតំណាងអ្នកអញ្ជើញទាំងអស់?",
      confirmClearAllTemplatesDesc: "សកម្មភាពនេះនឹងកំណត់តំណាងអ្នកអញ្ជើញទាំងអស់ទៅជាទទេ []។ ចុចរក្សាទុកដើម្បីធ្វើបច្ចុប្បន្នភាពទៅកាន់ម៉ាស៊ីនបម្រើ។",
      linkPreviewTitle: "ចំណងជើងតំណចែករំលែក",
      linkPreviewDescription: "ការពិពណ៌នាតំណចែករំលែក",
      guestInviteMessageDesc: "កែសម្រួលសារអញ្ជើញសម្រាប់ផ្ញើលើតេឡេក្រាម",
      linkPreviewTitleDesc: "កែសម្រួលចំណងជើង និងការពិពណ៌នានៃតំណចែករំលែក",
      saveGuestInviteSuccess: "បានធ្វើបច្ចុប្បន្នភាពសារអញ្ជើញភ្ញៀវដោយជោគជ័យ",
      saveLinkPreviewSuccess: "បានធ្វើបច្ចុប្បន្នភាពចំណងជើងតំណចែករំលែកដោយជោគជ័យ",
      resetToDefault: "កំណត់ឡើងវិញតាមគំរូដើម",
      resetToDefaultSuccess: "បានកំណត់ឡើងវិញតាមគំរូដើមដោយជោគជ័យ",
      invitationMessage: "សារអញ្ជើញ",
      seoMessage: "សារ SEO",
      seoTitle: "ចំណងជើង SEO",
      seoDescription: "ការពិពណ៌នា SEO",
      saveMessagesSuccess: "បានធ្វើបច្ចុប្បន្នភាពសារ & SEO ដោយជោគជ័យ",
      failedToLoadMessages: "មិនអាចទាញយកព័ត៌មានការកំណត់សារ & SEO បានទេ",
      saveMessagesError: "មិនអាចធ្វើបច្ចុប្បន្នភាពការកំណត់សារ & SEO បានទេ",
      languageEn: "ភាសាអង់គ្លេស",
      languageKh: "ភាសាខ្មែរ",
      languageCh: "ភាសាចិន",
      // Contact Us
      feedback: "មតិយោបល់",
      selectTopic: "ជ្រើសរើសប្រធានបទ",
      generalQuestion: "សំណួរទូទៅ",
      partnership: "ភាពជាដៃគូ",
      feedbackTab: "មតិយោបល់",
      phoneNumber: "លេខទូរស័ព្ទ",
      companyName: "ឈ្មោះក្រុមហ៊ុន",
      inquiryTopic: "ប្រធានបទសំណួរ",
      partnershipType: "ប្រភេទភាពជាដៃគូ",
      feedbackType: "ប្រភេទមតិយោបល់",
      ratingLabel: "ការវាយតម្លៃ",
      howCanWeHelp: "តើយើងអាចជួយអ្វីបាន?",
      proposalDetails: "ព័ត៌មានលម្អិតអំពីសំណើ",
      yourFeedback: "មតិយោបល់ / ការណែនាំរបស់អ្នក",
      submitMessage: "បញ្ជូន",
      submitSuccess: "សូមអរគុណ! សាររបស់អ្នកត្រូវបានផ្ញើដោយជោគជ័យ។",
      submitError: "ការបញ្ជូនបរាជ័យ។ សូមព្យាយាមម្ដងទៀត។",
      optional: "ស្រេចចិត្ត",
      required: "ចាំបាច់",
      pricingPackages: "តម្លៃ និងកញ្ចប់",
      customDesignTheme: "រចនាតាមបំណង និងរចនាបទ",
      guestListQR: "បញ្ជីភ្ញៀវ និង QR កូដ",
      technicalAccountHelp: "ជំនួយបច្ចេកទេស និងគណនី",
      otherQuestion: "សំណួរផ្សេងៗ",
      eventPlannerAgency: "អ្នករៀបចំកម្មវិធី / ភ្នាក់ងារ",
      designerArtist: "អ្នករចនា និងសិល្បករ",
      vendorSponsor: "អ្នកផ្គត់ផ្គង់ និងអ្នកឧបត្ថម្ភ",
      affiliateReseller: "សម្ព័ន្ធ និងអ្នកលក់បន្ត",
      otherCollaboration: "កិច្ចសហការផ្សេងៗ",
      testimonial: "ការវាយតម្លៃ",
      suggestion: "ការណែនាំ",
      issueReport: "រាយការណ៍បញ្ហា",
      emailUs: "ផ្ញើអ៊ីមែល",
      callUs: "ហៅទូរស័ព្ទ",
      visitUs: "មកទស្សនា",
      companyAddress: "ផ្លូវ ១៩៨៤ ភ្នំពេញ កម្ពុជា",
      typicalResponseTime: "ពេលវេលាឆ្លើយតបធម្មតា: ក្នុងរយៈពេល ២ម៉ោង",
      fullNameRequired: "ត្រូវការឈ្មោះពេញ",
      emailRequired: "ត្រូវការអ៊ីមែល",
      emailInvalid: "សូមបញ្ចូលអ៊ីមែលត្រឹមត្រូវ",
      messageRequired: "ត្រូវការសារ",
      phoneMinLength: "លេខទូរស័ព្ទត្រូវមានយ៉ាងហោចណាស់ ៦ខ្ទង់",
      phoneMaxLength: "លេខទូរស័ព្ទមិនអាចលើសពី ១២ខ្ទង់ទេ",
      companyNameRequired: "ត្រូវការឈ្មោះក្រុមហ៊ុន",
      // Thank You Message
      thankYouMessage: "សារថ្លែងអំណរគុណ",
      thankYouSubtitle: "កំណត់រូបថត វីដេអូ និងសារថ្លែងអំណរគុណសម្រាប់ភ្ញៀវ",
      thankYouPhotoTitle: "រូបថតថ្លែងអំណរគុណ",
      thankYouVideoLinkTitle: "តំណវីដេអូថ្លែងអំណរគុណ (ជម្រើស)",
      thankYouMessageTextTitle: "អត្ថបទសារថ្លែងអំណរគុណ",
      thankYouImage: "រូបភាពថ្លែងអំណរគុណ",
      thankYouVideoLink: "តំណវីដេអូថ្លែងអំណរគុណ",
      message: "សារ",
      messageKh: "សារ (ខ្មែរ)",
      messageEn: "សារ (អង់គ្លេស)",
      messageCh: "សារ (ចិន)",
      thankYouSaveSuccess: "បានរក្សាទុកសារថ្លែងអំណរគុណដោយជោគជ័យ",
      thankYouSaveError: "បរាជ័យក្នុងការរក្សាទុកសារថ្លែងអំណរគុណ",
      uploadThankYouPhoto: "បញ្ចូលរូបថតថ្លែងអំណរគុណ",
      uploadImage: "បញ្ចូលរូបភាព",
      changeImage: "ផ្លាស់ប្ដូររូបភាព",
      removeImage: "លុបរូបភាព",
      uploading: "កំពុងបញ្ចូល...",
      uploadFailed: "បរាជ័យក្នុងការបញ្ចូល",
      fileUploadedSuccessfully: "បានបញ្ចូលរូបភាពដោយជោគជ័យ",
      mediaDeletedSuccessfully: "បានលុបរូបភាពដោយជោគជ័យ",
      // SEO Preview Enhancement
      editMode: "កែសម្រួល",
      previewMode: "មើលជាមុន",
      socialSharePreview: "មើលជាមុនការចែករំលែកបណ្ដាញសង្គម",
      invitationMessagePreview: "មើលជាមុនសារអញ្ជើញ",
      noImageSelected: "គ្មានរូបភាពត្រូវបានជ្រើសរើស",
      eventInvitation: "ការអញ្ជើញចូលរួមកម្មវិធី",
      pleaseAttendOurSpecialDay: "សូមអញ្ជើញចូលរួមកម្មវិធីពិសេសរបស់យើង",
      enterInvitationMessage: "បញ្ចូលសារអញ្ជើញដើម្បីមើលជាមុន",
      // User Guide
      userGuide: "របៀបប្រើប្រាស់",
      userGuideTitle: "របៀបប្រើប្រាស់",
      userGuideSubtitle: "រៀនពីរបៀបរៀបចំ និងគ្រប់គ្រងលិខិតអញ្ជើញឌីជីថលរបស់អ្នក។",
      searchGuidePlaceholder: "ស្វែងរករបៀបប្រើប្រាស់តាមចំណងជើង មុខងារ ឬកម្មវិធី...",
      gettingStarted: "ចាប់ផ្តើមដំបូង",
      gettingStartedDesc: "វីដេអូបង្រៀនចាប់ផ្តើមដំបូងនឹងមានក្នុងពេលឆាប់ៗនេះ។",
      noGettingStartedVideo: "មិនទាន់មានវីដេអូចាប់ផ្តើមដំបូងនៅឡើយទេ។",
      guidesByEvent: "របៀបប្រើប្រាស់តាមកម្មវិធី",
      guidesByEventDesc: "ជ្រើសរើសប្រភេទកម្មវិធីដើម្បីមើលវីដេអូបង្រៀនជាក់លាក់។",
      allEvents: "កម្មវិធីទាំងអស់",
      featureGuides: "របៀបប្រើប្រាស់មុខងារ",
      featureGuidesDesc: "រៀនពីរបៀបគ្រប់គ្រងភ្ញៀវ, ការឆ្លើយតប RSVP, ចំណងដៃ, ពរជ័យ និងការកំណត់។",
      watchGuide: "ទស្សនារបៀបប្រើប្រាស់",
      viewGuides: "មើលរបៀបប្រើប្រាស់",
      exploreTutorials: "ស្វែងយល់ពីវីដេអូបង្រៀន និងគន្លឹះរៀបចំ",
      prevVideo: "វីដេអូមុន",
      nextVideo: "វីដេអូបន្ទាប់",
      videoCounter: "{{current}} / {{total}} វីដេអូ",
      upNext: "វីដេអូបន្ទាប់ ({{count}})",
      part: "ភាគទី {{number}}",
      partGuide: "ភាគទី {{order}} • របៀបប្រើប្រាស់ E-THEAP",
      noEventGuidesTitle: "មិនទាន់មានរបៀបប្រើប្រាស់តាមកម្មវិធីនៅឡើយទេ",
      noEventGuidesDesc: "មិនទាន់មានវីដេអូបង្រៀនសម្រាប់ប្រភេទកម្មវិធីនេះនៅឡើយទេ។",
      noFeatureGuidesTitle: "មិនទាន់មានរបៀបប្រើប្រាស់មុខងារនៅឡើយទេ",
      noFeatureGuidesDesc: "សូមត្រឡប់មកពិនិត្យមើលឡើងវិញក្នុងពេលឆាប់ៗសម្រាប់វីដេអូបង្រៀនមុខងារថ្មីៗ។",
      noGuidesForEventDesc: "មិនទាន់មានវីដេអូសម្រាប់កម្មវិធីនេះនៅឡើយទេ។",
    },
  },
};

const getStoredLanguage = async (): Promise<string> => {
  try {
    if (cloudStorage.isSupported()) {
      const storedLang = await cloudStorage.getItem(LANGUAGE_STORAGE_KEY);
      return storedLang || "en";
    }
  } catch (error) {
    console.warn("Failed to load language from CloudStorage:", error);
  }

  return localStorage.getItem(LANGUAGE_STORAGE_KEY) || "en";
};

const saveLanguage = async (language: string): Promise<void> => {
  try {
    if (cloudStorage.isSupported()) {
      await cloudStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  } catch (error) {
    console.warn("Failed to save language to CloudStorage:", error);
  }

  localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
};

getStoredLanguage().then((storedLanguage) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = storedLanguage;
  }
  i18n.use(initReactI18next).init({
    resources,
    lng: storedLanguage,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });
});

i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.lang = lng;
  }
  saveLanguage(lng);
});

export default i18n;
export { saveLanguage, getStoredLanguage };
